// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/NB-International-Pro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/GTPressuraMonoTrial-Rg.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /*
! tailwindcss v3.4.16 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

/*
Remove the default font size and weight for headings.
*/

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

/*
Add the correct font weight in Edge and Safari.
*/

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

/*
Add the correct font size in all browsers.
*/

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

/*
Use the modern Firefox focus style for all focusable elements.
*/

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

/*
Add the correct display in Chrome and Safari.
*/

/*
Removes the default spacing and border for appropriate elements.
*/

/*
Reset default styling for dialogs.
*/

/*
Prevent resizing textareas horizontally by default.
*/

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

/*
Set the default cursor for buttons.
*/

/*
Make sure disabled buttons don't get the pointer cursor.
*/

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

/* Make elements with the HTML hidden attribute stay hidden by default */

@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.16 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}::before,
::after {
  --tw-content: '';
}/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}/*
Remove the default font size and weight for headings.
*/h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}/*
Reset links to optimize for opt-in styling instead of opt-out.
*/a {
  color: inherit;
  text-decoration: inherit;
}/*
Add the correct font weight in Edge and Safari.
*/b,
strong {
  font-weight: bolder;
}/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}/*
Add the correct font size in all browsers.
*/small {
  font-size: 80%;
}/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}sub {
  bottom: -0.25em;
}sup {
  top: -0.5em;
}/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}/*
Remove the inheritance of text transform in Edge and Firefox.
*/button,
select {
  text-transform: none;
}/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}/*
Use the modern Firefox focus style for all focusable elements.
*/:-moz-focusring {
  outline: auto;
}/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/:-moz-ui-invalid {
  box-shadow: none;
}/*
Add the correct vertical alignment in Chrome and Firefox.
*/progress {
  vertical-align: baseline;
}/*
Correct the cursor style of increment and decrement buttons in Safari.
*/::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}/*
Remove the inner padding in Chrome and Safari on macOS.
*/::-webkit-search-decoration {
  -webkit-appearance: none;
}/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}/*
Add the correct display in Chrome and Safari.
*/summary {
  display: list-item;
}/*
Removes the default spacing and border for appropriate elements.
*/blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}fieldset {
  margin: 0;
  padding: 0;
}legend {
  padding: 0;
}ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}/*
Reset default styling for dialogs.
*/dialog {
  padding: 0;
}/*
Prevent resizing textareas horizontally by default.
*/textarea {
  resize: vertical;
}/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}/*
Set the default cursor for buttons.
*/button,
[role="button"] {
  cursor: pointer;
}/*
Make sure disabled buttons don't get the pointer cursor.
*/:disabled {
  cursor: default;
}/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/img,
video {
  max-width: 100%;
  height: auto;
}/* Make elements with the HTML hidden attribute stay hidden by default */[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}:root {
    --background: 0 0% 100%;
    --foreground: 222.2 47.4% 11.2%;
    --muted: 210 40% 96.1%;
    --muted-foreground: 215.4 16.3% 46.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 222.2 47.4% 11.2%;
    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --card: 0 0% 100%;
    --card-foreground: 222.2 47.4% 11.2%;
    --primary: 222.2 47.4% 11.2%;
    --primary-foreground: 210 40% 98%;
    --secondary: 210 40% 96.1%;
    --secondary-foreground: 222.2 47.4% 11.2%;
    --accent: 210 40% 96.1%;
    --accent-foreground: 222.2 47.4% 11.2%;
    --destructive: 0 100% 50%;
    --destructive-foreground: 210 40% 98%;
    --ring: 215 20.2% 65.1%;
    --radius: 0.5rem;
    /* JEN Colors */
    /* #c7c7c7  */
    --jen-grey-1: 204, 17%, 92%;
    /* #EAEDEF */
    --jen-grey-2: 0, 0%, 78%;
    /* #9A9D9F */
    --jen-grey-3: 210, 3%, 61%;
    /* #2b2d2e  */
    --jen-grey-4: 210, 3%, 18%;
    --jen-orange: 255 91 39;
    --jen-yellow: 255 171 57;
    --jen-dark-yellow: 43 36 26;
    --jen-green: 62 208 120;
    /* #202223 */
    --jen-black: 20 22 23;
    --jen-white: 255 255 255;
    --jen-dark-grey: 64 68 70;
    --jen-mid-grey: 154 157 159;
    --jen-light-grey: 223 228 231;
    --jen-lightest-grey: 241 244 247;
    --jen-red: 255 66 25;
    --jen-blue: 16 102 229;
    /* new */
    --content-primary: #111112;
    --content-primary-contrast: #f6f6f7;
    --content-secondary: #484b4b;
    --content-tertiary: #71717a;
    --interactive-primary: #ff5b27;
    --interactive-primary-hover: rgba(255,91,39,0.8);
    --interactive-secondary: #48484b;
    --interactive-secondary-hover: #373739;
    --interactive-tertiary: #9d9da6;
    --interactive-tertiary-bg-hover: #e1e2e4;
    --interactive-tertiary-hover: #373739;
    --interactive-track: rgba(0,0,0,0.2);
    --interactive-track-hover: #ff5b27;
    --background-primary: #ffffff;
    --background-secondary: #f6f6f7;
    --background-tertiary: #f6f6f7;
    --interactive-accent: rgba(255,91,39,0.2);
    --border: #cecfd3;
    --border-primary: #ebebee;
    --negative-sentiment: #cc1900;
    --positive-sentiment: #3ed078;
    --track-selected: #111112;
    --active-primary: #ff5b27;
    --active-hover: rgba(255,91,39,0.8);
    --active-bg: rgba(255,91,39,0.2);
    --active-border: rgba(255,91,39,0.6);
    --disabled: #cecfd3;
  }.dark {
    --background: 224 71% 4%;
    --foreground: 213 31% 91%;
    --muted: 223 47% 11%;
    --muted-foreground: 215.4 16.3% 56.9%;
    --accent: 216 34% 17%;
    --accent-foreground: 210 40% 98%;
    --popover: 224 71% 4%;
    --popover-foreground: 215 20.2% 65.1%;
    --border: 216 34% 17%;
    --input: 216 34% 17%;
    --card: 224 71% 4%;
    --card-foreground: 213 31% 91%;
    --primary: 210 40% 98%;
    --primary-foreground: 222.2 47.4% 1.2%;
    --secondary: 222.2 47.4% 11.2%;
    --secondary-foreground: 210 40% 98%;
    --destructive: 0 63% 31%;
    --destructive-foreground: 210 40% 98%;
    --ring: 216 34% 17%;
    /* new */
    --content-primary: #f6f6f7;
    --content-primary-contrast: #111112;
    --content-secondary: #cecfd3;
    --content-tertiary: #67666d;
    --interactive-primary: #ff5b27;
    --interactive-primary-hover: rgba(255,91,39,0.8);
    --interactive-secondary: #f6f6f7;
    --interactive-secondary-hover: #373739;
    --interactive-tertiary: #48484b;
    --interactive-tertiary-bg-hover: #373739;
    --interactive-tertiary-hover: #f6f6f7;
    --interactive-track: rgba(255,255,255,0.4);
    --interactive-track-hover: #ff5b27;
    --background-primary: #000000;
    --background-secondary: #111112;
    --background-tertiary: #111112;
    --interactive-accent: rgba(255,91,39,0.2);
    --border: #373739;
    --border-primary: #ebebee;
    --negative-sentiment: #cc1900;
    --positive-sentiment: #3ed078;
    --track-selected: #111112;
    --active-primary: #ff5b27;
    --active-hover: rgba(255,91,39,0.8);
    --active-bg: rgba(255,91,39,0.2);
    --active-border: rgba(255,91,39,0.6);
    --disabled: #67666d;
  }

.pointer-events-none:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  pointer-events: none;
}

.pointer-events-auto:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  pointer-events: auto;
}

.invisible:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  visibility: hidden;
}

.fixed:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  position: fixed;
}

.absolute:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  position: absolute;
}

.relative:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  position: relative;
}

.inset-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.bottom-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  bottom: 0px;
}

.left-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  left: 0px;
}

.left-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  left: 0.25rem;
}

.left-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  left: 0.5rem;
}

.left-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  left: 0.75rem;
}

.left-\\[50\\%\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  left: 50%;
}

.right-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  right: 0px;
}

.right-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  right: 0.25rem;
}

.right-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  right: 0.5rem;
}

.right-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  right: 0.75rem;
}

.right-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  right: 1rem;
}

.top-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  top: 0px;
}

.top-1\\/2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  top: 50%;
}

.top-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  top: 0.5rem;
}

.top-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  top: 1rem;
}

.top-\\[26px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  top: 26px;
}

.top-\\[50\\%\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  top: 50%;
}

.z-40:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  z-index: 40;
}

.z-50:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  z-index: 50;
}

.z-\\[100\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  z-index: 100;
}

.-mx-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.mx-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.mx-auto:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-left: auto;
  margin-right: auto;
}

.my-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.my-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.my-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.mb-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-bottom: 0.5rem;
}

.mb-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-bottom: 0.75rem;
}

.mb-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-bottom: 1rem;
}

.mb-5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-bottom: 1.25rem;
}

.mb-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-bottom: 1.5rem;
}

.ml-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-left: 0.25rem;
}

.ml-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-left: 1.5rem;
}

.ml-auto:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-left: auto;
}

.mr-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-right: 0.25rem;
}

.mr-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-right: 0.5rem;
}

.mr-jen-spacing-24:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-right: 24px;
}

.mt-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 0.25rem;
}

.mt-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 0.5rem;
}

.mt-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 0.75rem;
}

.mt-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 1rem;
}

.mt-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 1.5rem;
}

.mt-9:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 2.25rem;
}

.mt-\\[16px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 16px;
}

.mt-jen-spacing-12:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  margin-top: 12px;
}

.box-border:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  box-sizing: border-box;
}

.box-content:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  box-sizing: content-box;
}

.block:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  display: block;
}

.inline-block:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  display: inline-block;
}

.flex:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  display: flex;
}

.inline-flex:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  display: inline-flex;
}

.table:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  display: table;
}

.grid:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  display: grid;
}

.hidden:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  display: none;
}

.h-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 0.25rem;
}

.h-10:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 2.5rem;
}

.h-11:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 2.75rem;
}

.h-12:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 3rem;
}

.h-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 0.75rem;
}

.h-3\\.5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 0.875rem;
}

.h-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 1rem;
}

.h-5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 1.25rem;
}

.h-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 1.5rem;
}

.h-7:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 1.75rem;
}

.h-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 2rem;
}

.h-9:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 2.25rem;
}

.h-\\[18px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 18px;
}

.h-\\[24px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 24px;
}

.h-\\[400px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 400px;
}

.h-\\[44px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 44px;
}

.h-\\[48px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 48px;
}

.h-\\[64px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 64px;
}

.h-\\[var\\(--radix-select-trigger-height\\)\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: var(--radix-select-trigger-height);
}

.h-full:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 100%;
}

.h-px:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  height: 1px;
}

.max-h-96:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  max-height: 24rem;
}

.max-h-\\[calc\\(100vh-200px\\)\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  max-height: calc(100vh - 200px);
}

.max-h-screen:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  max-height: 100vh;
}

.min-h-full:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  min-height: 100%;
}

.w-10:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 2.5rem;
}

.w-11:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 2.75rem;
}

.w-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 0.75rem;
}

.w-3\\.5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 0.875rem;
}

.w-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 1rem;
}

.w-5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 1.25rem;
}

.w-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 1.5rem;
}

.w-7:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 1.75rem;
}

.w-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 2rem;
}

.w-9:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 2.25rem;
}

.w-\\[123px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 123px;
}

.w-\\[182px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 182px;
}

.w-\\[248px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 248px;
}

.w-\\[24px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 24px;
}

.w-\\[400px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 400px;
}

.w-\\[420px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 420px;
}

.w-\\[540px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 540px;
}

.w-\\[calc\\(100vw-16px\\)\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: calc(100vw - 16px);
}

.w-\\[calc\\(100vw-30px\\)\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: calc(100vw - 30px);
}

.w-fit:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: -moz-fit-content;
  width: fit-content;
}

.w-full:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 100%;
}

.min-w-\\[8rem\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  min-width: 8rem;
}

.min-w-\\[var\\(--radix-select-trigger-width\\)\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  min-width: var(--radix-select-trigger-width);
}

.max-w-\\[420px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  max-width: 420px;
}

.max-w-\\[640px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  max-width: 640px;
}

.max-w-\\[calc\\(100vw-16px\\)\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  max-width: calc(100vw - 16px);
}

.max-w-lg:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  max-width: 32rem;
}

.flex-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  flex: 1 1 0%;
}

.shrink-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  flex-shrink: 0;
}

.caption-bottom:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  caption-side: bottom;
}

.border-collapse:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-collapse: collapse;
}

.-translate-x-full:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: -100%;
  transform: translate(-100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: 0px;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-50\\%\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: -50%;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-full:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: 100%;
  transform: translate(100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-\\[-50\\%\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-full:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), 100%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.animate-spin:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  animation: spin 1s linear infinite;
}

.cursor-default:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  cursor: default;
}

.cursor-pointer:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  cursor: pointer;
}

.select-none:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.resize:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  resize: both;
}

.grid-cols-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.flex-col:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  flex-direction: column;
}

.flex-col-reverse:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  flex-direction: column-reverse;
}

.items-center:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  align-items: center;
}

.justify-start:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  justify-content: flex-start;
}

.justify-center:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  justify-content: center;
}

.justify-between:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  justify-content: space-between;
}

.gap-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 0.25rem;
}

.gap-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 0.5rem;
}

.gap-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 0.75rem;
}

.gap-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 1rem;
}

.gap-5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 1.25rem;
}

.gap-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 1.5rem;
}

.gap-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 2rem;
}

.gap-\\[10px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 10px;
}

.gap-\\[12px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 12px;
}

.gap-\\[6px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  gap: 6px;
}

.space-x-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * 0);
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * (1 - 0));
  margin-left: calc(0.25rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.25rem * calc(1 - 0));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * 0);
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * (1 - 0));
  margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(1rem * calc(1 - 0));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * (1 - 0));
  margin-top: calc(0.25rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.25rem * calc(1 - 0));
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * 0);
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-1\\.5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * (1 - 0));
  margin-top: calc(0.375rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.375rem * calc(1 - 0));
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * 0);
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.space-y-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * (1 - 0));
  margin-top: calc(0.5rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.5rem * calc(1 - 0));
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * 0);
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.space-y-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * (1 - 0));
  margin-top: calc(1rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(1rem * calc(1 - 0));
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * 0);
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.overflow-auto:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  overflow: auto;
}

.overflow-hidden:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  overflow: hidden;
}

.overflow-y-auto:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  overflow-y: auto;
}

.whitespace-nowrap:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  white-space: nowrap;
}

.rounded:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 0.25rem;
}

.rounded-\\[16px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 16px;
}

.rounded-\\[4px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 4px;
}

.rounded-full:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 9999px;
}

.rounded-lg:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 0.5rem;
}

.rounded-md:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 0.375rem;
}

.rounded-sm:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 0.125rem;
}

.rounded-xl:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-radius: 0.75rem;
}

.rounded-bl-md:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-bottom-left-radius: 0.375rem;
}

.rounded-tl-md:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-top-left-radius: 0.375rem;
}

.border:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-width: 1px;
}

.border-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-width: 2px;
}

.border-\\[1px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-width: 1px;
}

.border-b:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-bottom-width: 1px;
}

.border-t:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-top-width: 1px;
}

.border-none:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-style: none;
}

.border-\\[\\#d4d4da\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-border-opacity: 1;
  border-color: rgba(212, 212, 218, 1);
  border-color: rgba(212, 212, 218, var(--tw-border-opacity, 1));
}

.border-destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-color: hsl(0, 100%, 50%);
  border-color: hsl(var(--destructive));
}

.border-input:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-color: hsl(214.3, 31.8%, 91.4%);
  border-color: hsl(var(--input));
}

.border-jen-border-primary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-color: #ebebee;
  border-color: var(--border-primary);
}

.border-jen-content-primary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-color: #111112;
  border-color: var(--content-primary);
}

.border-jen-disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-color: #cecfd3;
  border-color: var(--disabled);
}

.border-transparent:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-color: transparent;
}

.bg-\\[\\#747479\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(116, 116, 121, 1);
  background-color: rgba(116, 116, 121, var(--tw-bg-opacity, 1));
}

.bg-\\[\\#9d9da6\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(157, 157, 166, 1);
  background-color: rgba(157, 157, 166, var(--tw-bg-opacity, 1));
}

.bg-\\[\\#FF5B271A\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: rgba(255,91,39,0.10196);
}

.bg-\\[\\#bc3229\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(188, 50, 41, 1);
  background-color: rgba(188, 50, 41, var(--tw-bg-opacity, 1));
}

.bg-\\[\\#ebebee\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(235, 235, 238, 1);
  background-color: rgba(235, 235, 238, var(--tw-bg-opacity, 1));
}

.bg-\\[\\#f7f7f7\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(247, 247, 247, 1);
  background-color: rgba(247, 247, 247, var(--tw-bg-opacity, 1));
}

.bg-\\[\\#f8d7ce\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 215, 206, 1);
  background-color: rgba(248, 215, 206, var(--tw-bg-opacity, 1));
}

.bg-\\[\\#ff5b27\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 91, 39, 1);
  background-color: rgba(255, 91, 39, var(--tw-bg-opacity, 1));
}

.bg-\\[\\#fff\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.bg-accent:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(210, 40%, 96.1%);
  background-color: hsl(var(--accent));
}

.bg-background:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.bg-black:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity, 1));
}

.bg-black\\/60:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: rgba(0, 0, 0, 0.6);
}

.bg-card:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(0, 0%, 100%);
  background-color: hsl(var(--card));
}

.bg-destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(0, 100%, 50%);
  background-color: hsl(var(--destructive));
}

.bg-gray-200:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity, 1));
}

.bg-gray-400:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(156, 163, 175, 1);
  background-color: rgba(156, 163, 175, var(--tw-bg-opacity, 1));
}

.bg-jen-background-primary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: #ffffff;
  background-color: var(--background-primary);
}

.bg-jen-background-secondary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: #f6f6f7;
  background-color: var(--background-secondary);
}

.bg-jen-interactive-accent:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: rgba(255,91,39,0.2);
  background-color: var(--interactive-accent);
}

.bg-jen-orange:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: rgb(255, 91, 39);
  background-color: rgb(var(--jen-orange));
}

.bg-muted:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: hsla(0, 0%, 20%, 1);
  background-color: hsla(0, 0%, 20%, var(--tw-bg-opacity, 1));
}

.bg-muted\\/50:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsla(0, 0%, 20%, 0.5);
}

.bg-primary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(222.2, 47.4%, 11.2%);
  background-color: hsl(var(--primary));
}

.bg-secondary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(210, 40%, 96.1%);
  background-color: hsl(var(--secondary));
}

.bg-transparent:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: transparent;
}

.bg-white:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.bg-opacity-50:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 0.5;
}

.p-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 0px;
}

.p-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 0.25rem;
}

.p-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 0.5rem;
}

.p-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 0.75rem;
}

.p-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 1rem;
}

.p-5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 1.25rem;
}

.p-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 1.5rem;
}

.p-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 2rem;
}

.p-\\[14px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 14px;
}

.p-jen-spacing-16:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding: 16px;
}

.px-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\\.5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.py-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.pb-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-bottom: 0.75rem;
}

.pb-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-bottom: 1rem;
}

.pb-5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-bottom: 1.25rem;
}

.pb-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-bottom: 1.5rem;
}

.pl-7:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-left: 1.75rem;
}

.pl-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-left: 2rem;
}

.pr-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-right: 0.5rem;
}

.pr-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-right: 2rem;
}

.pt-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 0px;
}

.pt-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 0.25rem;
}

.pt-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 1.5rem;
}

.pt-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-top: 2rem;
}

.text-left:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  text-align: left;
}

.text-center:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  text-align: center;
}

.text-right:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  text-align: right;
}

.align-middle:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  vertical-align: middle;
}

.font-pressura-mono:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-family: GT Pressura Mono Trial, monospace;
}

.text-\\[0\\.8rem\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 0.8rem;
}

.text-\\[12px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 12px;
}

.text-\\[14px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 14px;
}

.text-\\[16px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 16px;
}

.text-\\[18px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 18px;
}

.text-\\[20px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 20px;
}

.text-\\[26px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 26px;
}

.text-\\[36px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 36px;
}

.text-\\[54px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 54px;
}

.text-\\[64px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 64px;
}

.text-jen-size-heading-02:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 24px;
  line-height: 24px;
  letter-spacing: -0.48px;
}

.text-jen-size-heading-04:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.48px;
}

.font-\\[400\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-weight: 400;
}

.font-medium:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-weight: 500;
}

.font-normal:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-weight: 400;
}

.font-semibold:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  font-weight: 600;
}

.uppercase:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  text-transform: uppercase;
}

.leading-\\[100\\%\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  line-height: 100%;
}

.leading-\\[120\\%\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  line-height: 120%;
}

.leading-\\[140\\%\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  line-height: 140%;
}

.leading-\\[20px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  line-height: 20px;
}

.leading-\\[24px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  line-height: 24px;
}

.leading-none:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  line-height: 1;
}

.tracking-\\[-0\\.14px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  letter-spacing: -0.14px;
}

.tracking-\\[-0\\.32px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  letter-spacing: -0.32px;
}

.tracking-\\[-0\\.4px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  letter-spacing: -0.4px;
}

.tracking-\\[-0\\.6px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  letter-spacing: -0.6px;
}

.tracking-\\[-1\\.04px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  letter-spacing: -1.04px;
}

.tracking-tight:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  letter-spacing: -0.025em;
}

.text-\\[\\#111112\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(17, 17, 18, 1);
  color: rgba(17, 17, 18, var(--tw-text-opacity, 1));
}

.text-\\[\\#48484b\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(72, 72, 75, 1);
  color: rgba(72, 72, 75, var(--tw-text-opacity, 1));
}

.text-\\[\\#747479\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(116, 116, 121, 1);
  color: rgba(116, 116, 121, var(--tw-text-opacity, 1));
}

.text-\\[\\#bc3229\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(188, 50, 41, 1);
  color: rgba(188, 50, 41, var(--tw-text-opacity, 1));
}

.text-\\[\\#ff5b27\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(255, 91, 39, 1);
  color: rgba(255, 91, 39, var(--tw-text-opacity, 1));
}

.text-\\[\\#fff\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));
}

.text-accent-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--accent-foreground));
}

.text-black:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity, 1));
}

.text-card-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--card-foreground));
}

.text-current:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: currentColor;
}

.text-destructive-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(210, 40%, 98%);
  color: hsl(var(--destructive-foreground));
}

.text-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--foreground));
}

.text-foreground\\/50:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsla(222.2, 47.4%, 11.2%, 0.5);
  color: hsl(var(--foreground) / 0.5);
}

.text-jen-content-primary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: #111112;
  color: var(--content-primary);
}

.text-jen-content-secondary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: #484b4b;
  color: var(--content-secondary);
}

.text-jen-content-tertiary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: #71717a;
  color: var(--content-tertiary);
}

.text-jen-disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: #cecfd3;
  color: var(--disabled);
}

.text-jen-grey-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(210, 3%, 61%);
  color: hsl(var(--jen-grey-3));
}

.text-jen-negative-sentiment:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: #cc1900;
  color: var(--negative-sentiment);
}

.text-jen-orange:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: rgb(255, 91, 39);
  color: rgb(var(--jen-orange));
}

.text-popover-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--popover-foreground));
}

.text-primary:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--primary));
}

.text-primary-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(210, 40%, 98%);
  color: hsl(var(--primary-foreground));
}

.text-secondary-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--secondary-foreground));
}

.underline:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  text-decoration-line: underline;
}

.underline-offset-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  text-underline-offset: 4px;
}

.antialiased:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.placeholder-\\[\\#71717a\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(113, 113, 122, 1);
  color: rgba(113, 113, 122, var(--tw-placeholder-opacity, 1));
}

.placeholder-\\[\\#71717a\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(113, 113, 122, 1);
  color: rgba(113, 113, 122, var(--tw-placeholder-opacity, 1));
}

.opacity-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 0;
}

.opacity-50:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 0.5;
}

.opacity-90:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 0.9;
}

.shadow-lg:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.shadow-md:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.shadow-sm:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.outline-none:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  outline-style: solid;
}

.ring-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.ring-offset-background:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-offset-color: #fff;
}

.transition-all:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-transform:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-200:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-duration: 200ms;
}

.duration-300:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-duration: 300ms;
}

.ease-in-out:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

body:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#),
#root:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  width: 100vw;
  height: 100vh;
  /* https://www.reddit.com/r/css/comments/12mh0ac/safari_mobile_does_not_respect_height_100vh/ */
  height: 100dvh;
  font-family: 'JenFont', sans-serif;
  -webkit-font-smoothing: antialiased;
}
@font-face {
  font-family: 'JenFont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'GTFont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

.file\\:border-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::file-selector-button {
  background-color: transparent;
}

.file\\:font-medium:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::file-selector-button {
  font-weight: 500;
}

.file\\:text-foreground:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)::file-selector-button {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--foreground));
}

.focus-within\\:relative:focus-within:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  position: relative;
}

.focus-within\\:z-20:focus-within:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  z-index: 20;
}

.hover\\:border-\\[\\#ff5b27\\]:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-border-opacity: 1;
  border-color: rgba(255, 91, 39, 1);
  border-color: rgba(255, 91, 39, var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#bc3229\\]:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(188, 50, 41, 1);
  background-color: rgba(188, 50, 41, var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#fff\\]:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[rgba\\(255\\2c 91\\2c 39\\2c 0\\.10\\)\\]:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: rgba(255,91,39,0.10);
}

.hover\\:bg-accent:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(210, 40%, 96.1%);
  background-color: hsl(var(--accent));
}

.hover\\:bg-destructive\\/90:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsla(0, 100%, 50%, 0.9);
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-jen-background-secondary:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: #f6f6f7;
  background-color: var(--background-secondary);
}

.hover\\:bg-jen-orange:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: rgb(255, 91, 39);
  background-color: rgb(var(--jen-orange));
}

.hover\\:bg-muted\\/50:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsla(0, 0%, 20%, 0.5);
}

.hover\\:bg-primary:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(222.2, 47.4%, 11.2%);
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary\\/90:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsla(222.2, 47.4%, 11.2%, 0.9);
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-secondary:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(210, 40%, 96.1%);
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsla(210, 40%, 96.1%, 0.8);
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:text-accent-foreground:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--accent-foreground));
}

.hover\\:text-foreground:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--foreground));
}

.hover\\:text-gray-900:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, 1);
  color: rgba(17, 24, 39, var(--tw-text-opacity, 1));
}

.hover\\:text-primary-foreground:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(210, 40%, 98%);
  color: hsl(var(--primary-foreground));
}

.hover\\:underline:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 1;
}

.hover\\:opacity-80:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 0.8;
}

.hover\\:opacity-90:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 0.9;
}

.focus\\:bg-accent:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(210, 40%, 96.1%);
  background-color: hsl(var(--accent));
}

.focus\\:bg-primary:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(222.2, 47.4%, 11.2%);
  background-color: hsl(var(--primary));
}

.focus\\:text-accent-foreground:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--accent-foreground));
}

.focus\\:text-primary-foreground:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(210, 40%, 98%);
  color: hsl(var(--primary-foreground));
}

.focus\\:opacity-100:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 1;
}

.focus\\:outline-none:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-ring:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus-visible\\:ring-\\[rgba\\(255\\2c 91\\2c 39\\2c 0\\.20\\)\\]:focus-visible:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-color: rgba(255,91,39,0.20);
}

.focus-visible\\:ring-ring:focus-visible:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-2:focus-visible:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-ring-offset-color: #fff;
}

.disabled\\:pointer-events-none:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  cursor: not-allowed;
}

.disabled\\:border-gray-300:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity, 1));
}

.disabled\\:bg-gray-100:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-50:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 0.5;
}

.group:hover:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-hover\\:opacity-100 {
  opacity: 1;
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsla(0, 0%, 20%, 0.4);
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgba(252, 165, 165, 1);
  color: rgba(252, 165, 165, var(--tw-text-opacity, 1));
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsla(0, 100%, 50%, 0.3);
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(0, 100%, 50%);
  background-color: hsl(var(--destructive));
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(210, 40%, 98%);
  color: hsl(var(--destructive-foreground));
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgba(254, 242, 242, 1);
  color: rgba(254, 242, 242, var(--tw-text-opacity, 1));
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(248, 113, 113, var(--tw-ring-opacity, 1));
}

.group.destructive:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}

.aria-selected\\:bg-accent[aria-selected="true"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(210, 40%, 96.1%);
  background-color: hsl(var(--accent));
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsla(210, 40%, 96.1%, 0.5);
  background-color: hsl(var(--accent) / 0.5);
}

.aria-selected\\:text-accent-foreground[aria-selected="true"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--accent-foreground));
}

.aria-selected\\:opacity-100[aria-selected="true"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 1;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  pointer-events: none;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), 0.25rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: -0.25rem;
  transform: translate(-0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: 0.25rem;
  transform: translate(0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), -0.25rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-5[data-state="checked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: 1.25rem;
  transform: translate(1.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: 0px;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: 0px;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=active\\]\\:border-b-2[data-state="active"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-bottom-width: 2px;
}

.data-\\[state\\=checked\\]\\:border-\\[\\#ff5b27\\][data-state="checked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-border-opacity: 1;
  border-color: rgba(255, 91, 39, 1);
  border-color: rgba(255, 91, 39, var(--tw-border-opacity, 1));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1));
}

.data-\\[state\\=checked\\]\\:bg-\\[\\#ff5b27\\][data-state="checked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 91, 39, 1);
  background-color: rgba(255, 91, 39, var(--tw-bg-opacity, 1));
}

.data-\\[state\\=checked\\]\\:bg-\\[rgba\\(255\\2c 91\\2c 39\\2c 0\\.20\\)\\][data-state="checked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: rgba(255,91,39,0.20);
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(222.2, 47.4%, 11.2%);
  background-color: hsl(var(--primary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: hsla(0, 0%, 20%, 1);
  background-color: hsla(0, 0%, 20%, var(--tw-bg-opacity, 1));
}

.data-\\[state\\=unchecked\\]\\:bg-\\[\\#747479\\][data-state="unchecked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(116, 116, 121, 1);
  background-color: rgba(116, 116, 121, var(--tw-bg-opacity, 1));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(214.3, 31.8%, 91.4%);
  background-color: hsl(var(--input));
}

.data-\\[placeholder\\]\\:text-jen-content-tertiary[data-placeholder]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: #71717a;
  color: var(--content-tertiary);
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: hsl(222.2, 47.4%, 11.2%);
  color: hsl(var(--foreground));
}

.data-\\[state\\=active\\]\\:text-jen-content-primary[data-state="active"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  color: #111112;
  color: var(--content-primary);
}

.data-\\[state\\=checked\\]\\:text-\\[\\#ff5b27\\][data-state="checked"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-text-opacity: 1;
  color: rgba(255, 91, 39, 1);
  color: rgba(255, 91, 39, var(--tw-text-opacity, 1));
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  transition-property: none;
}

.disabled\\:data-\\[state\\=checked\\]\\:bg-gray-300[data-state="checked"]:disabled:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, 1);
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity, 1));
}

@media (min-width: 640px) {

  .sm\\:bottom-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    bottom: 0px;
  }

  .sm\\:right-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    right: 0px;
  }

  .sm\\:top-auto:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    top: auto;
  }

  .sm\\:flex-row:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    flex-direction: row;
  }

  .sm\\:flex-col:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    flex-direction: column;
  }

  .sm\\:justify-end:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    justify-content: flex-end;
  }

  .sm\\:space-x-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * 0);
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * (1 - 0));
    margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - 0));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * 0);
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * (1 - 0));
    margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(1rem * calc(1 - 0));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * (1 - 0));
    margin-top: calc(0px * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(0px * calc(1 - 0));
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * 0);
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:text-left:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    text-align: left;
  }
}

@media (min-width: 768px) {

  .md\\:max-w-\\[420px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    max-width: 420px;
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    grid-column: span 2 / span 2;
  }

  .lg\\:row-span-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    grid-row: span 1 / span 1;
  }

  .lg\\:row-span-2:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    grid-row: span 2 / span 2;
  }

  .lg\\:w-\\[160px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    width: 160px;
  }

  .lg\\:w-\\[384px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    width: 384px;
  }

  .lg\\:flex-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    flex: 1 1 0%;
  }

  .lg\\:grid-cols-3:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-rows-\\[177px_102px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    grid-template-rows: 177px 102px;
  }

  .lg\\:p-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    padding: 2rem;
  }

  .lg\\:px-8:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-6:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:pb-5:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    padding-bottom: 1.25rem;
  }

  .lg\\:pt-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    padding-top: 0px;
  }

  .lg\\:pt-jen-spacing-24:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    padding-top: 24px;
  }

  .lg\\:text-\\[64px\\]:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
    font-size: 64px;
  }
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsl(210, 40%, 96.1%);
  background-color: hsl(var(--accent));
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  background-color: hsla(210, 40%, 96.1%, 0.5);
  background-color: hsl(var(--accent) / 0.5);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) {
  padding-right: 0px;
}

.\\[\\&\\>span\\]\\:line-clamp-1:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#)>tr {
  border-bottom-width: 0px;
}

.\\[\\&_svg\\]\\:pointer-events-none:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) svg {
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) svg {
  flex-shrink: 0;
}

.\\[\\&_tr\\:last-child\\]\\:border-0:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) tr:last-child {
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b:not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#):not(#\\#) tr {
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";EAGE;;CAAc,CAAd;;;CAAc;;AAAd;;;;;;;;CAAc;;AAAd;;;CAAc;;AAAd;;;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;;;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;;;CAAc;;AAAd;;;;CAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;CAAc;;AAAd;;CAAc;;AAAd;;;;CAAc;;AAAd;;CAAc;;AAAd,wEAAc;;AAQd;;EAAA;IAAA;EAAmB;AAAA,CARnB;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc,CAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA,CAAd;;EAAA,gBAAc;AAAA,CAAd;;;;;;;;CAAc,CAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,8LAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA,CAAd;;;CAAc,CAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA,CAAd;;;;CAAc,CAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA,CAAd;;CAAc,CAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,cAAc;EAAd,wBAAc;AAAA,CAAd;;CAAc,CAAd;;EAAA,mBAAc;AAAA,CAAd;;;;;CAAc,CAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,cAAc;AAAA,CAAd;;CAAc,CAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA,CAAd;EAAA,eAAc;AAAA,CAAd;EAAA,WAAc;AAAA,CAAd;;;;CAAc,CAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA,CAAd;;;;CAAc,CAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;;EAAA,oBAAc;AAAA,CAAd;;;CAAc,CAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,aAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,gBAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,wBAAc;AAAA,CAAd;;CAAc,CAAd;;EAAA,YAAc;AAAA,CAAd;;;CAAc,CAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,wBAAc;AAAA,CAAd;;;CAAc,CAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,kBAAc;AAAA,CAAd;;CAAc,CAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA,CAAd;EAAA,SAAc;EAAd,UAAc;AAAA,CAAd;EAAA,UAAc;AAAA,CAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,UAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,gBAAc;AAAA,CAAd;;;CAAc,CAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA,CAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;;EAAA,eAAc;AAAA,CAAd;;CAAc,CAAd;EAAA,eAAc;AAAA,CAAd;;;;CAAc,CAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA,CAAd;;CAAc,CAAd;;EAAA,eAAc;EAAd,YAAc;AAAA,CAAd,wEAAc,CAAd;EAAA,aAAc;AAAA,CAAd;IAAA,uBAAc;IAAd,+BAAc;IAAd,sBAAc;IAAd,qCAAc;IAAd,oBAAc;IAAd,uCAAc;IAAd,2BAAc;IAAd,0BAAc;IAAd,iBAAc;IAAd,oCAAc;IAAd,4BAAc;IAAd,iCAAc;IAAd,0BAAc;IAAd,yCAAc;IAAd,uBAAc;IAAd,sCAAc;IAAd,yBAAc;IAAd,qCAAc;IAAd,uBAAc;IAAd,gBAAc;IAAd,eAAc;IAAd,aAAc;IAAd,2BAAc;IAAd,YAAc;IAAd,wBAAc;IAAd,YAAc;IAAd,0BAAc;IAAd,aAAc;IAAd,0BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,YAAc;IAAd,qBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,2BAAc;IAAd,6BAAc;IAAd,gCAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,QAAc;IAAd,0BAAc;IAAd,mCAAc;IAAd,4BAAc;IAAd,2BAAc;IAAd,8BAAc;IAAd,gDAAc;IAAd,gCAAc;IAAd,sCAAc;IAAd,+BAAc;IAAd,wCAAc;IAAd,qCAAc;IAAd,oCAAc;IAAd,kCAAc;IAAd,6BAAc;IAAd,+BAAc;IAAd,8BAAc;IAAd,yCAAc;IAAd,iBAAc;IAAd,yBAAc;IAAd,6BAAc;IAAd,6BAAc;IAAd,yBAAc;IAAd,yBAAc;IAAd,mCAAc;IAAd,gCAAc;IAAd,oCAAc;IAAd,mBAAc;EAAA,CAAd;IAAA,wBAAc;IAAd,yBAAc;IAAd,oBAAc;IAAd,qCAAc;IAAd,qBAAc;IAAd,gCAAc;IAAd,qBAAc;IAAd,qCAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,kBAAc;IAAd,8BAAc;IAAd,sBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,mCAAc;IAAd,wBAAc;IAAd,qCAAc;IAAd,mBAAc;IAAd,QAAc;IAAd,0BAAc;IAAd,mCAAc;IAAd,4BAAc;IAAd,2BAAc;IAAd,8BAAc;IAAd,gDAAc;IAAd,gCAAc;IAAd,sCAAc;IAAd,+BAAc;IAAd,wCAAc;IAAd,qCAAc;IAAd,0CAAc;IAAd,kCAAc;IAAd,6BAAc;IAAd,+BAAc;IAAd,8BAAc;IAAd,yCAAc;IAAd,iBAAc;IAAd,yBAAc;IAAd,6BAAc;IAAd,6BAAc;IAAd,yBAAc;IAAd,yBAAc;IAAd,mCAAc;IAAd,gCAAc;IAAd,oCAAc;IAAd,mBAAc;EAAA;;AAQd;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+BAAmB;EAAnB,uDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,8BAAmB;EAAnB,sDAAmB;EAAnB,mCAAmB;EAAnB,2DAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,4BAAmB;EAAnB,oDAAmB;EAAnB,iCAAmB;EAAnB,yDAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,mCAAmB;EAAnB,2DAAmB;EAAnB,uCAAmB;EAAnB,+DAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,wCAAmB;EAAnB,gEAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,kCAAmB;EAAnB,0DAAmB;EAAnB,sCAAmB;EAAnB,8DAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,gCAAmB;EAAnB,wDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,mFAAmB;EAAnB,mGAAmB;EAAnB,wHAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iFAAmB;EAAnB,iGAAmB;EAAnB,sHAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAiIrB;;EAEE,YAAY;EACZ,aAAa;EACb,+FAA+F;EAC/F,cAAc;EACd,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,+DAA8E;EAC9E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;AACpB;;AAjKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,+BAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,sBAkKA;EAlKA,kCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,sCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,wCAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,sCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,yCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,yBAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kCAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,0CAkKA;EAlKA;AAkKA;;AAlKA;EAAA,gDAkKA;EAlKA;AAkKA;;AAlKA;EAAA,sCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,4CAkKA;EAlKA;AAkKA;;AAlKA;EAAA,+BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,+BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,oBAkKA;EAlKA,0BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,yBAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,sCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,0CAkKA;EAlKA;AAkKA;;AAlKA;EAAA,+BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,yBAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,8BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,2GAkKA;EAlKA,yGAkKA;EAlKA,kFAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,8BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,2GAkKA;EAlKA,yGAkKA;EAlKA,kFAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,sBAkKA;EAlKA,oCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,wCAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,oBAkKA;EAlKA,6BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,qCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,mCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,yBAkKA;EAlKA;AAkKA;;AAlKA;EAAA,oBAkKA;EAlKA,6BAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,oBAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,sCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,4CAkKA;EAlKA;AAkKA;;AAlKA;EAAA,+BAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,yBAkKA;EAlKA,iLAkKA;EAlKA;AAkKA;;AAlKA;EAAA,0BAkKA;EAlKA,kLAkKA;EAlKA;AAkKA;;AAlKA;EAAA,yBAkKA;EAlKA,iLAkKA;EAlKA;AAkKA;;AAlKA;EAAA,0BAkKA;EAlKA,kLAkKA;EAlKA;AAkKA;;AAlKA;EAAA,yBAkKA;EAlKA,iLAkKA;EAlKA;AAkKA;;AAlKA;EAAA,qBAkKA;EAlKA,6KAkKA;EAlKA;AAkKA;;AAlKA;EAAA,qBAkKA;EAlKA,6KAkKA;EAlKA;AAkKA;;AAlKA;EAAA,gDAkKA;EAlKA;AAkKA;;AAlKA;EAAA,iDAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,sBAkKA;EAlKA,kCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,wCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,sCAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,0CAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,qCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,wCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,0CAkKA;EAlKA;AAkKA;;AAlKA;EAAA,cAkKA;EAlKA;AAkKA;;AAlKA;EAAA,+BAkKA;EAlKA;AAkKA;;AAlKA;EAAA,cAkKA;EAlKA;AAkKA;;AAlKA;EAAA,oBAkKA;EAlKA,2BAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,4CAkKA;EAlKA,uDAkKA;EAlKA,iFAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,kBAkKA;EAlKA,wCAkKA;EAlKA;AAkKA;;AAlKA;;EAAA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA,uBAkKA;IAlKA,8BAkKA;IAlKA,sDAkKA;IAlKA,mCAkKA;IAlKA,2DAkKA;IAlKA,uCAkKA;IAlKA;EAkKA;;EAlKA;IAAA,uBAkKA;IAlKA,4BAkKA;IAlKA,oDAkKA;IAlKA,iCAkKA;IAlKA,yDAkKA;IAlKA,qCAkKA;IAlKA;EAkKA;;EAlKA;IAAA,uBAkKA;IAlKA,+BAkKA;IAlKA,uDAkKA;IAlKA,mCAkKA;IAlKA,2DAkKA;IAlKA,4BAkKA;IAlKA;EAkKA;;EAlKA;IAAA;EAkKA;AAAA;;AAlKA;;EAAA;IAAA;EAkKA;AAAA;;AAlKA;;EAAA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA,kBAkKA;IAlKA;EAkKA;;EAlKA;IAAA,mBAkKA;IAlKA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;;EAlKA;IAAA;EAkKA;AAAA;;AAlKA;EAAA,sCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,gCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,iCAkKA;EAlKA;AAkKA;;AAlKA;EAAA,4CAkKA;EAlKA;AAkKA;;AAlKA;EAAA,iCAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,gBAkKA;EAlKA,oBAkKA;EAlKA,4BAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA,WAkKA;EAlKA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA;;AAlKA;EAAA;AAkKA","sourcesContent":["@layer tailwind-base, components, utils;\n\n@layer tailwind-base {\n  @tailwind base;\n}\n\n@layer tailwind-components {\n  @tailwind components;\n}\n\n@layer tailwind-utils {\n  @tailwind utilities;\n}\n\n@layer base {\n  :root {\n    --background: 0 0% 100%;\n    --foreground: 222.2 47.4% 11.2%;\n    --muted: 210 40% 96.1%;\n    --muted-foreground: 215.4 16.3% 46.9%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 222.2 47.4% 11.2%;\n    --border: 214.3 31.8% 91.4%;\n    --input: 214.3 31.8% 91.4%;\n    --card: 0 0% 100%;\n    --card-foreground: 222.2 47.4% 11.2%;\n    --primary: 222.2 47.4% 11.2%;\n    --primary-foreground: 210 40% 98%;\n    --secondary: 210 40% 96.1%;\n    --secondary-foreground: 222.2 47.4% 11.2%;\n    --accent: 210 40% 96.1%;\n    --accent-foreground: 222.2 47.4% 11.2%;\n    --destructive: 0 100% 50%;\n    --destructive-foreground: 210 40% 98%;\n    --ring: 215 20.2% 65.1%;\n    --radius: 0.5rem;\n    /* JEN Colors */\n    /* #c7c7c7  */\n    --jen-grey-1: 204, 17%, 92%;\n    /* #EAEDEF */\n    --jen-grey-2: 0, 0%, 78%;\n    /* #9A9D9F */\n    --jen-grey-3: 210, 3%, 61%;\n    /* #2b2d2e  */\n    --jen-grey-4: 210, 3%, 18%;\n    --jen-orange: 255 91 39;\n    --jen-yellow: 255 171 57;\n    --jen-dark-yellow: 43 36 26;\n    --jen-green: 62 208 120;\n    /* #202223 */\n    --jen-black: 20 22 23;\n    --jen-white: 255 255 255;\n    --jen-dark-grey: 64 68 70;\n    --jen-mid-grey: 154 157 159;\n    --jen-light-grey: 223 228 231;\n    --jen-lightest-grey: 241 244 247;\n    --jen-red: 255 66 25;\n    --jen-blue: 16 102 229;\n    /* new */\n    --content-primary: #111112;\n    --content-primary-contrast: #f6f6f7;\n    --content-secondary: #484b4b;\n    --content-tertiary: #71717a;\n    --interactive-primary: #ff5b27;\n    --interactive-primary-hover: #ff5b27cc;\n    --interactive-secondary: #48484b;\n    --interactive-secondary-hover: #373739;\n    --interactive-tertiary: #9d9da6;\n    --interactive-tertiary-bg-hover: #e1e2e4;\n    --interactive-tertiary-hover: #373739;\n    --interactive-track: #00000033;\n    --interactive-track-hover: #ff5b27;\n    --background-primary: #ffffff;\n    --background-secondary: #f6f6f7;\n    --background-tertiary: #f6f6f7;\n    --interactive-accent: #ff5b2733;\n    --border: #cecfd3;\n    --border-primary: #ebebee;\n    --disabled: #cecfd3;\n    --negative-sentiment: #cc1900;\n    --positive-sentiment: #3ed078;\n    --track-selected: #111112;\n    --active-primary: #ff5b27;\n    --active-hover: #ff5b27cc;\n    --active-bg: #ff5b2733;\n    --active-border: #ff5b2799;\n    --disabled: #cecfd3;\n  }\n  .dark {\n    --background: 224 71% 4%;\n    --foreground: 213 31% 91%;\n    --muted: 223 47% 11%;\n    --muted-foreground: 215.4 16.3% 56.9%;\n    --accent: 216 34% 17%;\n    --accent-foreground: 210 40% 98%;\n    --popover: 224 71% 4%;\n    --popover-foreground: 215 20.2% 65.1%;\n    --border: 216 34% 17%;\n    --input: 216 34% 17%;\n    --card: 224 71% 4%;\n    --card-foreground: 213 31% 91%;\n    --primary: 210 40% 98%;\n    --primary-foreground: 222.2 47.4% 1.2%;\n    --secondary: 222.2 47.4% 11.2%;\n    --secondary-foreground: 210 40% 98%;\n    --destructive: 0 63% 31%;\n    --destructive-foreground: 210 40% 98%;\n    --ring: 216 34% 17%;\n    /* new */\n    --content-primary: #f6f6f7;\n    --content-primary-contrast: #111112;\n    --content-secondary: #cecfd3;\n    --content-tertiary: #67666d;\n    --interactive-primary: #ff5b27;\n    --interactive-primary-hover: #ff5b27cc;\n    --interactive-secondary: #f6f6f7;\n    --interactive-secondary-hover: #373739;\n    --interactive-tertiary: #48484b;\n    --interactive-tertiary-bg-hover: #373739;\n    --interactive-tertiary-hover: #f6f6f7;\n    --interactive-track: #ffffff66;\n    --interactive-track-hover: #ff5b27;\n    --background-primary: #000000;\n    --background-secondary: #111112;\n    --background-tertiary: #111112;\n    --interactive-accent: #ff5b2733;\n    --border: #373739;\n    --border-primary: #ebebee;\n    --disabled: #67666d;\n    --negative-sentiment: #cc1900;\n    --positive-sentiment: #3ed078;\n    --track-selected: #111112;\n    --active-primary: #ff5b27;\n    --active-hover: #ff5b27cc;\n    --active-bg: #ff5b2733;\n    --active-border: #ff5b2799;\n    --disabled: #67666d;\n  }\n}\n\nbody,\n#root {\n  width: 100vw;\n  height: 100vh;\n  /* https://www.reddit.com/r/css/comments/12mh0ac/safari_mobile_does_not_respect_height_100vh/ */\n  height: 100dvh;\n  font-family: 'JenFont', sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n@font-face {\n  font-family: 'JenFont';\n  src: url('./assets/fonts/NB-International-Pro-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'GTFont';\n  src: url('./assets/fonts/GTPressuraMonoTrial-Rg.woff') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
